import { render, staticRenderFns } from "./Surveys.vue?vue&type=template&id=76a60179&scoped=true"
import script from "./Surveys.vue?vue&type=script&lang=js"
export * from "./Surveys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a60179",
  null
  
)

export default component.exports